import { TThunkAction } from '../../types/redux';
import { setActiveTab } from './actions';
import { ETab } from '../../types/tab';
import { trackActiveTabChange } from './tracking/trackActiveTabChange';

enum ETabLabel {
  Cian = 'cian',
  Parsed = 'parsed',
  Question = 'question',
}

export function setActiveTabAction(tab: ETab): TThunkAction<Promise<void>> {
  return async dispatch => {
    let label = '';
    switch (tab) {
      case ETab.Questions:
        label = ETabLabel.Question;
        break;
      default:
        label = ETabLabel.Cian;
        break;
    }
    trackActiveTabChange(label);

    dispatch(setActiveTab(tab));
  };
}
